import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../01-HOME/02_SIDE-BAR/Sidebar";
import TopBar from "../../01-HOME/03-TOP-BAR/TopBar";

function Layout() {
  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar : hauteur fixe et fixe à gauche */}
      <Sidebar className="h-full" />

      <div className="flex-1 flex flex-col">
        {/* Top Bar : en haut avec une hauteur fixe */}
        <TopBar className="h-[40px]" />

        {/* Contenu principal : l'Outlet sera défilable */}
        <div
          className="flex-1 bg-[#F8F9FA] text-black overflow-auto"
          style={{
            height: "calc(100vh - 40px)", // Hauteur du contenu principale, moins la hauteur de la TopBar
            minHeight: "calc(100vh - 40px)",
          }}
        >
          {/* Rendu des pages enfants (via Outlet) */}
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout;